const { system } = require('styled-system');

const inset = system({
    inset: {
        property: 'inset',
        scale: 'space'
    }
});

module.exports = inset;
